<p-dialog [visible]="true" [modal]="true" [draggable]="false" [resizable]="false"
    styleClass="!rounded-2xl overflow-hidden shadow-2xl" contentStyleClass="!p-0 !overflow-y-hidden"
    maskStyleClass="!bg-slate-900/60 !backdrop-blur-sm" [style]="{ width: '600px', 'max-height': '90vh' }"
    [breakpoints]="{ '960px': '75vw', '640px': '95vw' }" (onHide)="onClose()" [showHeader]="false">

    <div class="flex flex-col bg-white">
        <!-- Header -->
        <div class="flex justify-between items-center px-8 py-5 border-b border-slate-100 bg-white">
            <div class="flex flex-col">
                <h2 class="text-xl font-extrabold text-[#253b5d] tracking-tight">
                    {{ (shift ? 'professionals_edit_shift_title' : 'professionals_new_shift_modal_title') | translate }}
                </h2>
                <p *ngIf="shift && (shift.schedule_id || shift.id)"
                    class="text-[8px] font-black text-slate-400 uppercase tracking-widest mt-0.5">
                    ID: {{ shift.schedule_id || shift.id }}
                </p>
                <p *ngIf="!shift" class="text-[8px] font-black text-slate-400 uppercase tracking-widest mt-0.5">
                    {{ 'professionals_shift_subtitle' | translate }}
                </p>
            </div>
            <button (click)="onClose()"
                class="w-8 h-8 rounded-full flex items-center justify-center text-slate-400 hover:text-rose-500 hover:bg-rose-50 transition-all">
                <i class="pi pi-times"></i>
            </button>
        </div>

        <!-- Content -->
        <div class="px-8 py-8 overflow-y-auto max-h-[65vh]">
            <!-- Loading State -->
            <div *ngIf="fetching" class="flex flex-col items-center justify-center py-20 gap-4">
                <i class="pi pi-spin pi-spinner text-[#3b66f5] text-3xl"></i>
                <p class="text-slate-400 text-xs font-medium tracking-wide">{{ 'doctors_fetching_details' | translate }}
                </p>
            </div>

            <div *ngIf="!fetching">
                <div *ngIf="error"
                    class="mb-6 p-4 bg-rose-50 border border-rose-100 rounded-xl flex items-center gap-3">
                    <i class="pi pi-exclamation-circle text-rose-500"></i>
                    <p class="text-sm text-rose-600 font-semibold">{{ error }}</p>
                </div>

                <p-fluid>
                    <div class="flex flex-col gap-6 max-w-xl mx-auto">
                        <!-- Basic Info -->
                        <div class="flex flex-col gap-1.5">
                            <label class="text-[9px] font-black text-slate-400 uppercase tracking-widest">{{
                                'professionals_title_label' | translate }} <span class="text-rose-500">*</span></label>
                            <input pInputText [(ngModel)]="shiftTitle"
                                [placeholder]="'professionals_title_placeholder' | translate"
                                class="w-full !rounded-xl !py-3 !bg-slate-50 border-slate-100 focus:!border-primary transition-all" />
                        </div>

                        <div class="flex flex-col gap-1.5">
                            <label class="text-[9px] font-black text-slate-400 uppercase tracking-widest">{{
                                'professionals_doctor_name' | translate }} <span class="text-rose-500">*</span></label>
                            <p-select [options]="doctors" [(ngModel)]="selectedDoctorId" optionLabel="doctor_name"
                                optionValue="doctor_id" [filter]="true" filterBy="doctor_name" [showClear]="true"
                                [placeholder]="'professionals_select_professional' | translate" appendTo="body"
                                styleClass="w-full !rounded-xl !bg-slate-50 border-slate-100 h-[46px]"
                                panelStyleClass="!rounded-xl !mt-2 !shadow-2xl !border-slate-100 !p-2"
                                (onFilter)="onDoctorSearchInput($event)">
                            </p-select>
                        </div>

                        <!-- Week Days -->
                        <div class="flex flex-col gap-1.5">
                            <label class="text-[9px] font-black text-slate-400 uppercase tracking-widest">{{
                                'professionals_week_days' | translate }} <span class="text-rose-500">*</span></label>
                            <p-multiSelect [options]="daysOptions" [(ngModel)]="selectedDays" display="chip"
                                optionLabel="label" optionValue="value" appendTo="body"
                                styleClass="w-full !rounded-xl !bg-slate-50 border-slate-100 min-h-[46px]"
                                panelStyleClass="!rounded-xl !mt-2 !shadow-2xl !border-slate-100 !p-2">
                                <ng-template let-option pTemplate="item">
                                    {{ option.label | translate }}
                                </ng-template>
                                <ng-template let-value pTemplate="selectedItems">
                                    <div class="flex flex-wrap gap-1 p-1">
                                        <div *ngFor="let day of value"
                                            class="bg-primary/5 text-primary text-[10px] font-bold px-2 py-1 rounded-md border border-primary/10">
                                            {{ day.label | translate }}
                                        </div>
                                        <span *ngIf="!value || value.length === 0" class="text-slate-400 text-sm">
                                            {{ 'professionals_select_days' | translate }}
                                        </span>
                                    </div>
                                </ng-template>
                            </p-multiSelect>
                        </div>

                        <!-- Time Grid -->
                        <div class="grid grid-cols-2 gap-4">
                            <div class="flex flex-col gap-1.5">
                                <label class="text-[9px] font-black text-slate-400 uppercase tracking-widest">{{
                                    'professionals_time_start' | translate }} <span
                                        class="text-rose-500">*</span></label>
                                <p-select [options]="timeOptions" [(ngModel)]="startTime" optionLabel="label"
                                    optionValue="value" appendTo="body" dropdownIcon="pi pi-clock"
                                    styleClass="w-full !rounded-xl !bg-slate-50 border-slate-100 h-[46px]"
                                    panelStyleClass="!rounded-xl !mt-2 !shadow-2xl !border-slate-100 !p-2">
                                </p-select>
                            </div>
                            <div class="flex flex-col gap-1.5">
                                <label class="text-[9px] font-black text-slate-400 uppercase tracking-widest">{{
                                    'professionals_time_end' | translate }} <span class="text-rose-500">*</span></label>
                                <p-select [options]="timeOptions" [(ngModel)]="endTime" optionLabel="label"
                                    optionValue="value" appendTo="body" dropdownIcon="pi pi-clock"
                                    styleClass="w-full !rounded-xl !bg-slate-50 border-slate-100 h-[46px]"
                                    panelStyleClass="!rounded-xl !mt-2 !shadow-2xl !border-slate-100 !p-2">
                                </p-select>
                            </div>
                        </div>

                        <!-- Date Grid -->
                        <div class="grid grid-cols-2 gap-4">
                            <div class="flex flex-col gap-1.5">
                                <label class="text-[9px] font-black text-slate-400 uppercase tracking-widest">{{
                                    'professionals_date_start' | translate }} <span
                                        class="text-rose-500">*</span></label>
                                <p-datepicker [(ngModel)]="startDate" dateFormat="dd/mm/yy" [showIcon]="true"
                                    iconDisplay="input" appendTo="body" styleClass="w-full"
                                    inputStyleClass="w-full !rounded-xl !py-3 !bg-slate-50 border-slate-100">
                                </p-datepicker>
                            </div>
                            <div class="flex flex-col gap-1.5">
                                <label class="text-[9px] font-black text-slate-400 uppercase tracking-widest">{{
                                    'professionals_date_end' | translate }} <span class="text-rose-500">*</span></label>
                                <p-datepicker [(ngModel)]="endDate" dateFormat="dd/mm/yy" [showIcon]="true"
                                    iconDisplay="input" appendTo="body" styleClass="w-full"
                                    inputStyleClass="w-full !rounded-xl !py-3 !bg-slate-50 border-slate-100">
                                </p-datepicker>
                            </div>
                        </div>

                        <!-- Duration & Location -->
                        <div class="grid grid-cols-2 gap-4">
                            <div class="flex flex-col gap-1.5">
                                <label class="text-[9px] font-black text-slate-400 uppercase tracking-widest">{{
                                    'professionals_duration' | translate }} <span class="text-rose-500">*</span></label>
                                <p-select [options]="durationOptions" [(ngModel)]="duration" optionLabel="label"
                                    optionValue="value" appendTo="body"
                                    styleClass="w-full !rounded-xl !bg-slate-50 border-slate-100 h-[46px]"
                                    panelStyleClass="!rounded-xl !mt-2 !shadow-2xl !border-slate-100 !p-2">
                                    <ng-template pTemplate="item" let-o>{{ o.value }} {{ 'minutes' | translate }}</ng-template>
                                    <ng-template pTemplate="selectedItem" let-o><span *ngIf="o">{{ o.value }} {{ 'minutes' | translate }}</span></ng-template>
                                </p-select>
                            </div>
                            <div class="flex flex-col gap-1.5">
                                <label class="text-[9px] font-black text-slate-400 uppercase tracking-widest">{{
                                    'professionals_location_label' | translate }} <span
                                        class="text-rose-500">*</span></label>
                                <p-select [options]="locations" [(ngModel)]="selectedLocation" optionLabel="name"
                                    [placeholder]="'professionals_select_location' | translate" appendTo="body"
                                    styleClass="w-full !rounded-xl !bg-slate-50 border-slate-100 h-[46px]"
                                    panelStyleClass="!rounded-xl !mt-2 !shadow-2xl !border-slate-100 !p-2">
                                </p-select>
                            </div>
                        </div>
                    </div>
                </p-fluid>
            </div>
        </div>

        <!-- Footer -->
        <div class="px-8 py-5 border-t border-slate-100 bg-white flex justify-between items-center gap-4">
            <app-button [label]="'button_cancel' | translate" variant="ghost" (onClick)="onClose()"
                styleClass="!text-slate-400 hover:!text-slate-600 !shadow-none !px-0">
            </app-button>
            <app-button
                [label]="loading ? ('common_saving' | translate) : (shift ? ('common_update' | translate) : ('professionals_create_shift' | translate))"
                [loading]="loading" (onClick)="onSave()"
                styleClass="!rounded-full !py-2.5 !px-10 !bg-[#3b66f5] !text-[11px] !font-bold">
            </app-button>
        </div>
    </div>
</p-dialog>